import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, } from '@tanstack/react-router';
import { api, } from '../../../../api/Api.js';
import { Download, } from '../../../../pages/client/invoice/Download.js';
export const Route = createFileRoute('/client/invoice/download/$token')({
    component: DownloadWrapper,
    // prevent re-requesting tan on language switch
    shouldReload: false,
    async loader({ params }) {
        return await api.client.invoice.requestTan.request({
            token: params.token,
        });
    },
});
function DownloadWrapper() {
    const state = Route.useLoaderData();
    const { token } = Route.useParams();
    return (_jsx(Download, { token: token, state: state }));
}
//# sourceMappingURL=download.$token.js.map